import { Heading, Quote } from '@sparemin/blockhead';
import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ConfirmationModal from 'components/ConfirmationModal';
import Circular from 'components/icons/circular/Circular';
import Modal from 'components/Modal';
import { onDisplayTranscribeOversizedFileModal } from 'redux/modules/mixpanel';
import { hideModal, modalParamsSelector } from 'redux/modules/modal';
import { episodeTranscriptionModalBlock as block } from '../utils';

function EpisodeExceedsLimitsModalContents() {
  const { fileSize, episodeDuration } = useSelector(modalParamsSelector) || {};

  const dispatch = useDispatch();

  const handleHideModal = useCallback((): void => {
    dispatch(hideModal());
  }, [dispatch]);

  useEffect(() => {
    dispatch(onDisplayTranscribeOversizedFileModal(fileSize, episodeDuration));
  }, [dispatch, episodeDuration, fileSize]);

  return (
    <>
      <ConfirmationModal.Body className={block('body')}>
        <ConfirmationModal.Icon>
          <Circular>
            <Quote className={block('icon')} />
          </Circular>
        </ConfirmationModal.Icon>

        <ConfirmationModal.Title>
          This episode exceeds our limits
        </ConfirmationModal.Title>

        <ConfirmationModal.Content>
          <Heading level={2}>
            Sorry for the inconvenience, but the episode you selected is either
            too long or too large a file size for us to transcribe it. Your
            request is noted and we’ll do our best to support this soon.
          </Heading>
        </ConfirmationModal.Content>
      </ConfirmationModal.Body>

      <Modal.Footer>
        <Modal.FooterButtons fluid>
          <Modal.FooterButton theme="submit" onClick={handleHideModal}>
            Close
          </Modal.FooterButton>
        </Modal.FooterButtons>
      </Modal.Footer>
    </>
  );
}

export default EpisodeExceedsLimitsModalContents;
